// DATE
export const formatDate = date => {
  const d = new Date(date)
  let month = `${d.getMonth() + 1}`
  let day = `${d.getDate()}`
  const year = d.getFullYear()

  if (month.length < 2) month = `0${month}`
  if (day.length < 2) day = `0${day}`

  return `${year}-${month}-${day}`
}

// NUMBERS
export const formatDigitValue = value => {
  if (value === undefined || value === null || value === '0') return 0
  if (value === '-' || value === '-0' || value === '-0.') return value
  if (value === '-.') return '-0.'
  if (value === '0-') return '-'

  const lastKey = String(value).slice(-1)
  const oldValue = String(value).slice(0, -1)

  if (/^[0-9.]$/.test(lastKey)) {
    return value
  }

  return oldValue
}

// STRINGS
/**
 *
 * @param str
 * @param params typeof Array or Object
 * @returns String
 *
 * @example for Array:
 * str => "Lorem ohuem [:2] naledo baloe hublo hatosso [:1] azozo [:3]",
 * params => ["pereko", "papuato"],
 * result "Lorem ohuem papuato naledo baloe hublo hatosso pereko azozo [[:3]]";
 *
 * @example for Object:
 * str => "Lorem ohuem {:pereko} naledo baloe hublo hatosso {:papuato} azozo {:undef}",
 * params => {
 *      pereko: "pereko",
 *      papuato: "papuato"
 * },
 * result "Lorem ohuem pereko naledo baloe hublo hatosso papuato azozo {:undef}";
 */
export const replaceKeys = (str, params) => {
  if (typeof params !== 'object') {
    throw new Error(
      'Invalid argument. Argument [params] must be types [Object, Array]',
    )
  }

  if (Array.isArray(params)) {
    return params.reduce(
      (str, item, index) => str.replace(`[:${index + 1}]`, item),
      str,
    )
  }

  return Object.keys(params).reduce(
    (str, key) => str.replace(`{:${key}}`, params[key]),
    str,
  )
}

// OBJECTS
/**
 * @param object typeof Object
 * @param keys typeof Array
 * @returns {Object}
 */

export const removeUnnecessaryProps = (object, keys) =>
  Object.entries(object).reduce(
    (res, [key, value]) =>
      keys.indexOf(key) === -1 ? { ...res, [key]: value } : res,
    {},
  )
